import React, { useEffect, useState, useContext } from 'react'
import endpoint from "../../../auth/endpoint";
import { Link, Navigate } from "react-router-dom";
import Loader from "react-loader-advanced";
import {
    Form,
    Button,
    Modal,
} from "react-bootstrap";
import './printCauseList.css'
import { Context } from "../../../auth/Context";
import Swal from "sweetalert2";
import "../cases/SweetAlertOverrides.css";

const CauseListWithSisterArchive = () => {

    const { user, dispatch } = useContext(Context);
    const currentUser = user?.user;

    const [isLoading, setLoading] = useState(false);
    const [dailyCauseList, setDailyCauseList] = useState([]);
    const [attachRulingModal, setAttachRulingModal] = useState(false);
    const [caseToAttachRuling, setCaseToAttachRuling] = useState({ caseId: '', appealNo: '', adjournment_proof: '', dateHeld: '' })
    const [date, setDate] = useState('');

    // file validation state
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileError, setFileError] = useState('');

    const ALLOWED_TYPES = [
        'application/pdf',
        'image/png',
        'image/jpg',
        'image/jpeg',
        'application/msword', // .doc
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document' // .docx
    ];
    const MAX_FILE_SIZE = 1 * 1024 * 1024; // 1MB

    const handleFileChange = (e) => {
        setFileError('');
        const file = e.target.files && e.target.files[0];
        if (!file) {
            setSelectedFile(null);
            return;
        }
        if (!ALLOWED_TYPES.includes(file.type) && !/\.(doc|docx|pdf|png)$/i.test(file.name)) {
            setFileError('Only PDF, JPG, JPEG, PNG or DOC/DOCX files are allowed.');
            setSelectedFile(null);
            return;
        }
        if (file.size > MAX_FILE_SIZE) {
            setFileError('File must be 1MB or smaller.');
            setSelectedFile(null);
            return;
        }
        setSelectedFile(file);
        // attach to case state if needed
        setCaseToAttachRuling(prev => ({ ...prev, doc: file }));
    }

    const handleUploadAttachment = async (e) => {
        e.preventDefault();
        setFileError('');
        if (!selectedFile) {
            setFileError('Please select a file to upload.');
            return;
        }
        if (!ALLOWED_TYPES.includes(selectedFile.type) && !/\.(doc|docx|pdf|png)$/i.test(selectedFile.name)) {
            setFileError('Only PDF, JPG, JPEG, PNG or DOC/DOCX files are allowed.');
            return;
        }
        if (selectedFile.size > MAX_FILE_SIZE) {
            setFileError('File must be 1MB or smaller.');
            return;
        }

        // Proceed to upload (placeholder - adapt endpoint & fields as needed)
        try {
            setLoading(true);
            const formData = new FormData();
            formData.append('dateHeld', caseToAttachRuling.dateHeld || '');
            formData.append('caseId', caseToAttachRuling.caseId || '');
            formData.append('adjournment_proof', selectedFile)
            await endpoint.post(`case-diary/upload-result-of-application`, formData)
            console.log('File validated and ready to upload', selectedFile);
            // reset after successful upload
            handleFetchData(caseToAttachRuling && caseToAttachRuling.dateHeld);
            setAttachRulingModal(false);
            setSelectedFile(null);
            setCaseToAttachRuling({ caseId: '', appealNo: '', adjournment_proof: '', dateHeld: '' });
        } catch (err) {
            console.error(err);
            setFileError('Upload failed. Please try again.');
        } finally {
            setLoading(false);
        }
    }

    // Add this function to handle verify ruling
    const handleVerifyRuling = async (caseId, dateHeld) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "Do you really want to verify this case?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#28a745",
            cancelButtonColor: "#6c757d",
            confirmButtonText: "Yes!",
            customClass: {
                confirmButton: "swal2-confirm-green-text",
                cancelButton: "swal2-confirm-green-text",
            },
        });

        if (result.isConfirmed) {
            try {

                const response = await endpoint.post(`case-diary/approve-result-of-application`, { caseId: caseId, dateHeld: dateHeld });

                if (response.status === 200) {
                    Swal.fire("Verified!", "Court Ruling has been verified.", "success");
                    handleFetchData(dateHeld);
                } else {
                    Swal.fire("Failed!", "Unable to verify.", "error");
                }
            } catch (error) {
                console.error("Error performin verification:", error);
                const message =
                    error.response?.data?.message ||
                    "Something went wrong while deleting.";
                Swal.fire("Error!", message, "error");
            }
        }
    };


    const dateSuffix = (day) => {
        if ((day == 1) || (day == 21) || (day == 31)) {
            return day + '' + "st";
        } else if ((day == 2) || (day == 22)) {
            return day + '' + "nd";
        } else if ((day == 3) || (day == 23)) {
            return day + '' + "rd";
        } else {
            return day + '' + "th";
        }
    }

    const formattedDate = date && (new Date(date).toLocaleDateString('en-us', { weekday: "long" }) + ", " + dateSuffix(new Date(date).toLocaleDateString('en-us', { day: "numeric" })) + " day of " +
        new Date(date).toLocaleDateString('en-us', { month: "long" }) + ", " + new Date(date).toLocaleDateString('en-us', { year: "numeric" })).toUpperCase();

    const curDate = new Date()
    const dateStr = (curDate.toLocaleDateString('en-us', { weekday: "long" }) + ", " + dateSuffix(curDate.toLocaleDateString('en-us', { day: "numeric" })) + " day of " +
        curDate.toLocaleDateString('en-us', { month: "long" }) + ", " + curDate.toLocaleDateString('en-us', { year: "numeric" })).toUpperCase();

    const alphabetArray = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
    const alphabetForSisterCase = "abcdefghijklmnopqrstuvwxyz".split("");

    const todaysDate = () => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
        const day = String(currentDate.getDate()).padStart(2, '0');

        const formatDate = `${year}-${month}-${day}`;

        console.log("new", formatDate);
        return formatDate
    }

    const handleFetchData = async (date = null) => {
        setLoading(true)
        await endpoint.get(`/case-diary/new-day-history-list/${date}`)
            .then(({ data }) => {
                console.log("response with supplied data", data.data)
                let causeArr = data.data

                const groupedByLocation = causeArr.reduce((result, obj) => {
                    const location = obj.location || 'N/A'; // fallback if location is missing

                    if (!result[location]) {
                        result[location] = {};
                    }

                    const key = obj.CaseType.case_type + ' ' + obj.CaseTypeCategory.case_type_cat + ' ' + (obj.AdjournmentType.id == 2 ? obj.AdjournmentType.id : '');

                    if (!result[location][key]) {
                        result[location][key] = [];
                    }

                    result[location][key].push(obj);

                    return result;
                }, []);
                console.log("groupedPrayerByLocation", groupedByLocation)
                // return
                setDailyCauseList(groupedByLocation)

                setLoading(false)
            }).catch((err) => {
                console.log(err)
                setLoading(false)
            })
    }

    //function that adds "judgement" to heading
    const splitHeading = (str) => {
        const firstSpaceIndex = str.indexOf(' ')
        const firstPart = str.slice(0, firstSpaceIndex)
        return (firstPart + ' ' + 'Judgment').toUpperCase()
    }

    //function that removes the adjournment id from heading
    const removeNumber = (str) => {
        const result = str.replace(/[0-9]/g, '')
        return (result + ' ' + '(s)').toUpperCase()
    }

    return (
        <>
            <div id='divToPrint'>
                {/* <div className='row'>
                    <div className='col-md-12 text-center' style={{ textDecoration: `underline` }}> <span>IN THE SUPREME COURT OF NIGERIA</span><br />
                        HOLDEN AT ABUJA <br />
                        CAUSELIST FOR {date ? formattedDate : dateStr.toUpperCase()}
                    </div>
                </div> */}
                <div className='col-md-12 text-center' id='hideDate' style={{ textDecoration: `underline` }}> <h3>CAUSE LIST ARCHIVE</h3><br />
                </div>

                <div className='row mt-4'>
                    <div className='col'>
                        <label className='text-danger' id='hideDate'><i>**Please select date and click on search to print cause list archive**</i></label>
                        <div className="input-group mb-3" id='hideDate'>
                            <input type="date" className="form-control" aria-label="Recipient's username" aria-describedby="button-addon2"
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                            />
                            <div className="input-group-append">
                                <button className="btn btn-outline-primary" type="button" onClick={() => handleFetchData(date)} id="button-addon2">Search</button>
                            </div>
                        </div>

                    </div>
                    <div className='col'>

                    </div>
                </div>

                {isLoading && <Loader />}

                {!isLoading &&
                    <div className='row mt-4'>
                        <div className='col-md-12'>

                            {Object.entries(dailyCauseList).map(([location, groupings], locationIndex) => (
                                <div key={locationIndex}>
                                    {/* Location Header */}
                                    <div className='text-center mb-4' style={{ fontWeight: 'bold', fontSize: '18px', textDecoration: 'underline' }}>
                                       CAUSE LIST FOR {date ? formattedDate : dateStr.toUpperCase()} <br />
                                        {location.toUpperCase()}
                                    </div>

                                    {Object.entries(groupings).sort(([keyA], [keyB]) => {
                                        const isMotionA = keyA.toLowerCase().includes("motion");
                                        const isMotionB = keyB.toLowerCase().includes("motion");

                                        if (isMotionA && !isMotionB) return -1; // Motion first
                                        if (!isMotionA && isMotionB) return 1;  // Appeal after Motion

                                        return keyA.localeCompare(keyB); // alphabetical fallback
                                    }).map(([headings, items], index) => (
                                        <div className='causeListHeading' key={index}>
                                            <div className='text-center mb-2' style={{
                                                color: `${headings.toUpperCase().includes("CIVIL") ? 'green' : headings.toUpperCase().includes("CRIMINAL") ? "red" : headings.toUpperCase().includes("POLITICAL") ? "blue" : ""}`
                                            }}>
                                                {headings.includes(2) ? `${alphabetArray[index]}. ${splitHeading(headings)}` : `${alphabetArray[index]}. ${removeNumber(headings)}`}
                                            </div>

                                            <div className='table-reponsive'>
                                                <table className="table mb-5" style={{ width: `100%` }}>
                                                    <thead className="thead-light">
                                                        <tr style={{ border: `1px solid black` }}>
                                                            <th style={{ maxWidth: `5px`, border: `1px solid black` }}>SN.</th>
                                                            <th scope="col" style={{ border: `1px solid black` }}>APPEAL NO.</th>
                                                            {headings.toUpperCase().includes("APPEAL") ?
                                                                <>
                                                                    <th scope="col" style={{ border: `1px solid black` }}>APPELLANTS</th>
                                                                    <th scope="col" style={{ border: `1px solid black` }}>RESPONDENTS</th>
                                                                    <th scope="col" style={{ border: `1px solid black` }}>APPLICATIONS</th>
                                                                </>
                                                                : <>
                                                                    <th scope="col" style={{ border: `1px solid black` }}>PARTIES</th>
                                                                    <th scope="col" style={{ border: `1px solid black` }}>APPLICATIONS</th>
                                                                </>
                                                            }

                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {
                                                            items.map((item, index) => (
                                                                <>
                                                                    {item.CaseAttachementHistories && item.CaseAttachementHistories.map((Case, index2) => {
                                                                        const hasSisters = item.CaseAttachementHistories.length > 1;
                                                                    return (
                                                                        <tr key={`${index}-${index2}`} style={{ border: `1px solid black` }}>
                                                                            {(index2 === 0) && <td rowSpan={item.CaseAttachementHistories.length} style={{ border: `1px solid black` }}>{index + 1}.</td>}
                                                                            <td style={{ border: `1px solid black`, color: `${item.CaseType.case_color}` }}>{hasSisters ? `${alphabetForSisterCase[index2]}. ${Case.suite_no}` : Case.suite_no}
                                                                            </td>
                                                                            {headings.toUpperCase().includes("APPEAL") ?
                                                                                <>
                                                                                    <td style={{ whiteSpace: `normal`, border: `1px solid black` }}>
                                                                                        <tr>{Case.appellants} {Case.otherAppellantCount === 1 ? (
                                                                                            <><strong> & Anor </strong></>
                                                                                        ) : Case.otherAppellantCount > 1 ? (
                                                                                            <> & <strong>{Case.otherAppellantCount} Ors</strong></>
                                                                                        ) : (
                                                                                            ""
                                                                                        )}</tr>
                                                                                    </td>
                                                                                    <td style={{ whiteSpace: `normal`, border: `1px solid black` }}>
                                                                                        <tr>{Case.respondent}
                                                                                            {Case.otherRespondentCount === 1 ? (
                                                                                                <><strong> & Anor </strong></>
                                                                                            ) : Case.otherRespondentCount > 1 ? (
                                                                                                <> & <strong>{Case.otherRespondentCount} Ors</strong></>
                                                                                            ) : (
                                                                                                ""
                                                                                            )}</tr>
                                                                                    </td>
                                                                                    <td style={{ whiteSpace: `pre-wrap`, border: `1px solid black`, wordWrap: `break-word`}}>
                                                                                        {Case.caseDescriptions && Case.caseDescriptions.map((desc, descIndex) => ( <><br></br>
                                                                                            <tr style={{margin: '10px !important'}}>{descIndex + 1}. {desc?.description} </tr>
                                                                                        </>))}
                                                                                    </td>
                                                                                </>
                                                                                :
                                                                                <>
                                                                                    {/* <td style={{ whiteSpace: `normal` }}>{Case.parties}</td> */}
                                                                                    <td className='text-center' style={{ whiteSpace: `normal`, border: `1px solid black` }}>
                                                                                        <tr>{Case.appellants}{Case.otherAppellantCount === 1 ? (
                                                                                            <><strong> & Anor </strong></>
                                                                                        ) : Case.otherAppellantCount > 1 ? (
                                                                                            <> & <strong>{Case.otherAppellantCount} Ors</strong></>
                                                                                        ) : (
                                                                                            ""
                                                                                        )}</tr>
                                                                                        <tr><div className='mt-2 mb-2'>VS.</div></tr>
                                                                                        <tr>{Case.respondent}{Case.otherRespondentCount === 1 ? (
                                                                                            <><strong> & Anor </strong></>
                                                                                        ) : Case.otherRespondentCount > 1 ? (
                                                                                            <> & <strong>{Case.otherRespondentCount} Ors</strong></>
                                                                                        ) : (
                                                                                            ""
                                                                                        )}</tr>
                                                                                    </td>
                                                                                    <td style={{ whiteSpace: `pre-wrap`, border: `1px solid black`, wordWrap: `break-word`}}>
                                                                                        {Case.caseDescriptions && Case.caseDescriptions.map((desc, descIndex) => ( <><br></br>
                                                                                            <tr style={{margin: '10px !important'}}>{descIndex + 1}. {desc?.description} </tr>
                                                                                        </>))}
                                                                                    </td>

                                                                                </>
                                                                            }
                                                                        </tr>
                                                                    )})}
                                                                </>
                                                            ))
                                                        }
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ))}


                        </div>
                    </div>
                }

                {Object.entries(dailyCauseList).length > 0 &&
                    <div className='col-md-12 hideBtn'>
                        <button className="btn btn-outline-primary" type="button" onClick={() => window.print()} id="button-addon2">Print</button>
                    </div>
                }

                {/* attach ruling modal */}
                <Modal show={attachRulingModal} onHide={() => setAttachRulingModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Attach Ruling for {caseToAttachRuling && caseToAttachRuling.appealNo}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form>
                            {/* Date Held */}
                            <Form.Group className="mb-3">
                                <Form.Label>Select document</Form.Label>
                                <div className="position-relative w-100">
                                    <div style={{ width: "100%" }}>
                                        <input
                                            type='file'
                                            className='form-control'
                                            accept=".pdf,.png,.doc,.docx,application/pdf,image/png,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                            onChange={handleFileChange}
                                        />
                                    </div>
                                </div>
                                {fileError && <div className="text-danger mt-2">{fileError}</div>}
                            </Form.Group>
                            <div className="d-flex justify-content-end mt-3">
                                <Button
                                    variant="danger"
                                    onClick={() => {
                                        setAttachRulingModal(false)
                                        setCaseToAttachRuling({ caseId: '', appealNo: '', adjournment_proof: '' })
                                        setSelectedFile(null);
                                        // +                                   setFileError('');
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    variant="success"
                                    className="ms-2"
                                    disabled={isLoading}
                                    onClick={handleUploadAttachment}
                                >
                                    {isLoading ? "Uploading..." : "Submit"}
                                </Button>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
                {/* end attach ruling modal */}

                {/* begin verify confirmation modal */}
                <Modal show={attachRulingModal} onHide={() => setAttachRulingModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Attach Ruling for {caseToAttachRuling && caseToAttachRuling.appealNo}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form>
                            {/* Date Held */}
                            <Form.Group className="mb-3">
                                <Form.Label>Select document</Form.Label>
                                <div className="position-relative w-100">
                                    <div style={{ width: "100%" }}>
                                        <input
                                            type='file'
                                            className='form-control'
                                            accept=".pdf,.png,.doc,.docx,application/pdf,image/png,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                            onChange={handleFileChange}
                                        />
                                    </div>
                                </div>
                                {fileError && <div className="text-danger mt-2">{fileError}</div>}
                            </Form.Group>
                            <div className="d-flex justify-content-end mt-3">
                                <Button
                                    variant="danger"
                                    onClick={() => {
                                        setAttachRulingModal(false)
                                        setCaseToAttachRuling({ caseId: '', appealNo: '', adjournment_proof: '' })
                                        setSelectedFile(null);
                                        // +                                   setFileError('');
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    variant="success"
                                    className="ms-2"
                                    disabled={isLoading}
                                    onClick={handleUploadAttachment}
                                >
                                    {isLoading ? "Uploading..." : "Submit"}
                                </Button>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
                {/* end verify confirmation modal */}

            </div>
        </>

    )
}

export default CauseListWithSisterArchive